(function(){
  if (window.__localizationCustomBootstrapped) return;
  window.__localizationCustomBootstrapped = true;

  function formatOpts(container){
    container.querySelectorAll('.option').forEach(function(opt){
      if(opt.dataset.aligned) return;
      var name = opt.getAttribute('data-name');
      var cur = opt.getAttribute('data-currency');
      if(name && cur){
        opt.textContent = '';
        var wrapper = document.createElement('span'); wrapper.className = 'country-opt';
        var ns = document.createElement('span'); ns.className = 'country-opt-name'; ns.textContent = name;
        var ss = document.createElement('span'); ss.className = 'country-opt-sep'; ss.textContent = '|';
        var cs = document.createElement('span'); cs.className = 'country-opt-currency'; cs.textContent = cur;
        wrapper.append(ns, ss, cs); opt.appendChild(wrapper);
        opt.dataset.aligned = '1';
      }
    });
  }

  function initCountryAlign(){
    document.querySelectorAll('[name="country-switcher"]').forEach(function(sel){
      if(!sel.querySelector('option[data-name][data-currency]')) return;
      if(!sel.tomselect) return;
      var ts = sel.tomselect;
      sel.querySelectorAll('option').forEach(function(o){
        if(ts.options[o.value]){
          ts.options[o.value]['data-name'] = o.getAttribute('data-name');
          ts.options[o.value]['data-currency'] = o.getAttribute('data-currency');
        }
      });
      ts.settings.render = ts.settings.render || {};
      if(!ts.__countryAlignRenderApplied){
        ts.settings.render.option = function(data, escape){
          var n = data['data-name'] || '';
          var c = data['data-currency'] || '';
          return '<div class="option" data-name="' + escape(n) + '" data-currency="' + escape(c) + '"><span class="country-opt"><span class="country-opt-name">' + escape(n) + '</span><span class="country-opt-sep">|</span><span class="country-opt-currency">' + escape(c) + '</span></span></div>';
        };
        ts.__countryAlignRenderApplied = true;
        ts.clearCache();
      }
      formatOpts(ts.dropdown_content);
      if(!ts.__countryAlignDropdownHooked){
        ts.__countryAlignDropdownHooked = true;
        ts.on('dropdown_open', function(){ setTimeout(function(){ formatOpts(ts.dropdown_content); }, 30); });
      }
    });
  }

  function prioritizeSelectedOption(ts){
    if(!ts || !ts.dropdown_content) return;
    var value = String(ts.getValue ? ts.getValue() : ts.input.value);
    var selected = Array.prototype.find.call(
      ts.dropdown_content.querySelectorAll('[data-value]'),
      function(option){ return option.getAttribute('data-value') === value; }
    );
    if(!selected || !selected.parentNode) return;
    selected.parentNode.insertBefore(selected, selected.parentNode.firstElementChild);
    ts.dropdown_content.scrollTop = 0;
  }

  function syncDesktopLocalizationState(nav, localization){
    var isOpen = localization.querySelector('[data-localization-accordion][open], .ts-wrapper.dropdown-active');
    nav.classList.toggle('m-main-nav--localization-open', Boolean(isOpen));
  }

  function initDesktopFooterVisibility(){
    var nav = document.querySelector('.m-main-nav');
    var localization = nav && nav.querySelector('.m-main-nav__localization');
    var footer = document.querySelector('.o-footer-group');
    if(!nav || !localization || !footer || !('IntersectionObserver' in window)) return;

    if(nav.__desktopFooterVisibilityObserver){
      nav.__desktopFooterVisibilityObserver.disconnect();
    }

    var observer = new IntersectionObserver(function(entries){
      var footerVisible = entries.some(function(entry){ return entry.isIntersecting; });
      nav.classList.toggle('m-main-nav--footer-visible', footerVisible);

      if(footerVisible){
        localization.querySelectorAll('.custom-select').forEach(function(select){
          if(select.tomselect) select.tomselect.close();
        });
      }
    }, { threshold: 0 });

    observer.observe(footer);
    nav.__desktopFooterVisibilityObserver = observer;
  }

  function initCountryLanguageLocalization(){
    document.querySelectorAll('.js-country-language-localization').forEach(function(wrapper){
      var select = wrapper.querySelector('[name="country-switcher"]');
      var form = wrapper.querySelector('form');
      var countryInput = wrapper.querySelector('input[name="country_code"]');
      var languageInput = wrapper.querySelector('input[name="language_code"]');
      if(!select || !select.tomselect || !form || !countryInput || !languageInput) return;

      var ts = select.tomselect;
      if(ts.__countryLanguageLocalizationBound) return;
      ts.__countryLanguageLocalizationBound = true;
      ts.on('change', function(value){
        var option = Array.prototype.find.call(select.options, function(item){
          return item.value === String(value);
        });
        if(!option) return;
        countryInput.value = option.value;
        languageInput.value = option.getAttribute('data-default-language') || languageInput.value;
        form.submit();
      });
    });
  }

  function initDesktopLocalizationState(){
    var nav = document.querySelector('.m-main-nav');
    var localization = nav && nav.querySelector('.m-main-nav__localization');
    if(!nav || !localization) return;

    localization.querySelectorAll('[data-localization-accordion]').forEach(function(accordion){
      if(accordion.dataset.localizationAccordionBound) return;
      accordion.dataset.localizationAccordionBound = 'true';

      accordion.addEventListener('toggle', function(){
        if(accordion.open){
          localization.querySelectorAll('[data-localization-accordion][open]').forEach(function(other){
            if(other === accordion) return;
            other.querySelectorAll('.custom-select').forEach(function(select){
              if(select.tomselect) select.tomselect.close();
            });
            other.open = false;
          });
        } else {
          accordion.querySelectorAll('.custom-select').forEach(function(select){
            if(select.tomselect) select.tomselect.close();
          });
        }
        syncDesktopLocalizationState(nav, localization);
      });
    });

    localization.querySelectorAll('.custom-select').forEach(function(sel){
      if(!sel.tomselect || sel.tomselect.__desktopLocalizationStateBound) return;
      var ts = sel.tomselect;
      ts.__desktopLocalizationStateBound = true;

      ts.on('dropdown_open', function(){
        nav.classList.add('m-main-nav--localization-open');
        setTimeout(function(){ prioritizeSelectedOption(ts); }, 40);
      });
      ts.on('dropdown_close', function(){
        setTimeout(function(){
          syncDesktopLocalizationState(nav, localization);
        }, 0);
      });
    });

    syncDesktopLocalizationState(nav, localization);
  }

  window.addEventListener('load', function(){
    setTimeout(function(){ initCountryAlign(); initCountryLanguageLocalization(); initDesktopLocalizationState(); initDesktopFooterVisibility(); }, 500);
    setTimeout(function(){ initCountryAlign(); initCountryLanguageLocalization(); initDesktopLocalizationState(); initDesktopFooterVisibility(); }, 1500);
  });
  window.addEventListener('shopify:section:load', function(){
    setTimeout(function(){ initCountryAlign(); initCountryLanguageLocalization(); initDesktopLocalizationState(); initDesktopFooterVisibility(); }, 500);
  });
})();
